'use strict';


const
    storage = require('./universal.storage'),
    save = storage.save,
    load = storage.load,
    defaultFilename = 'config';

/**
 * core.module.ufs.load(function ( error, data) { ... });
 * core.module.ufs.save(, {qwe: 123});
 *
 * core.module.ufs.filename = 'config';
 *
 * core.module.ufs.loadSync();
 * core.module.ufs.saveSync({qwe: 123});
 *
 */
class Ufs {
    constructor ( appName ) {
        // create read-only property for own app files
        Object.defineProperty(this, 'appName', {
            value: appName,
            enumerable: false,
            configurable: false,
            writable: false
        });
    }

    /**
     * Asynchronously load data from '/mnt/Userfs/data/%appName%.config' file.
     *
     * @param {Function} [callback] - result callback
     *
     * @example
     * // load data from '/mnt/Userfs/data/%appName%.config'
     * core.plugins.ufs.load(function ( error, data ) {
     *     if ( error ) {
     *         throw error;
     *     }
     *     console.log(data);
     * });
     *
     * // load data from '/mnt/Userfs/data/%appName%.meta.info.ini'
     * core.plugins.ufs.fileName = 'meta.info.ini';
     *
     * core.plugins.ufs.load(function ( error, data ) {
     *     if ( error ) {
     *         throw error;
     *     }
     *     console.log(data);
     * });
     */
    load ( callback ) {
        let self = this;

        setTimeout(function () {
            callback(null, load(self.appName + '.' + self.filename));
        }, 0);
    }

    /**
     * Synchronously load data from '/mnt/Userfs/data/%appName%.config' file.
     *
     * @return {string|null} data file content string
     *
     * @example
     * // load data from '/mnt/Userfs/data/%appName%.config'
     * console.log(core.plugins.ufs.loadSync());
     *
     * // save data to '/mnt/Userfs/data/%appName%.meta.info.ini'.
     * core.plugins.ufs.fileName = 'meta.info.ini';
     *
     * console.log(core.plugins.ufs.loadSync());
     */
    loadSync () {
        return load(this.appName + '.' + this.filename);
    }


    /**
     * Asynchronously save data to file '/mnt/Userfs/data/%appName%.config'.
     *
     * @param {string} data - data to save
     * @param {Function} [callback] - result callback
     *
     *
     * @example
     * // save data to '/mnt/Userfs/data/%appName%.config'
     * core.plugins.ufs.save('sometext', function ( error, data ) {
     *     if ( error ) {
     *         throw error;
     *     }
     *     console.log(data);
     * });
     *
     * // save data to '/mnt/Userfs/data/%appName%.meta.info.ini'
     * core.plugins.ufs.fileName = 'meta.info.ini';
     *
     * core.plugins.ufs.save('sometext', function ( error, data ) {
     *     if ( error ) {
     *         throw error;
     *     }
     *     console.log(data);
     * });
     */
    save ( data, callback ) {
        let self = this;

        setTimeout(function () {
            callback(save(self.appName + '.' + self.filename, data));
        }, 0);
    }

    /**
     * Synchronously save data to file '/mnt/Userfs/data/%appName%.config'.
     *
     * @param {string} data - data to save
     * @return {boolean} save status
     *
     * @example
     *
     * // save data to '/mnt/Userfs/data/%appName%.config'
     * core.plugins.ufs.saveSync('sometext');
     *
     * // save data to '/mnt/Userfs/data/%appName%.meta.info.ini'
     * core.plugins.ufs.fileName = 'meta.info';
     *
     * core.plugins.ufs.saveSync('sometext');
     */
    saveSync ( data ) {
        return save(this.appName + '.' + this.filename, data);
    }
}

/**
 * Custom app file name postfix.
 *
 * @type {string}
 */
Ufs.prototype.filename = defaultFilename;


module.exports = Ufs;
